import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import SimpleReactValidator from 'simple-react-validator';
import { ConfigSyncListener, SupabaseListener } from './components/Utils';

import Core from './core';

// Set the app element for react-modal to prevent null reference errors
Modal.setAppElement('#root');

import './assets/scss/style.scss';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

const scrollToFirstValidationError = () => {
  const getErrorNodes = (root) =>
    Array.from(root.querySelectorAll('.input-error')).filter(
      (node) => node && node.textContent && node.textContent.trim() !== '',
    );

  const activeRoot =
    document.activeElement?.closest(
      'form, .widget, .modal-component, .content-wrapper, .page-components',
    ) || null;

  let errors = activeRoot ? getErrorNodes(activeRoot) : [];

  if (!errors.length) {
    errors = getErrorNodes(document);
  }

  if (!errors.length) {
    return;
  }

  const firstError = errors[0];
  const wrapper =
    firstError.closest('.input-wrapper') ||
    firstError.parentElement ||
    firstError;

  const field =
    wrapper.querySelector(
      'input, textarea, select, [role="combobox"], [contenteditable="true"]',
    ) || wrapper;

  field.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  });

  if (field && typeof field.focus === 'function') {
    setTimeout(() => field.focus({ preventScroll: true }), 220);
  }
};

if (
  SimpleReactValidator &&
  SimpleReactValidator.prototype &&
  !SimpleReactValidator.prototype.__scrollPatchApplied
) {
  const originalShowMessages = SimpleReactValidator.prototype.showMessages;

  SimpleReactValidator.prototype.showMessages = function patchedShowMessages() {
    const result = originalShowMessages.call(this);
    window.requestAnimationFrame(() => {
      setTimeout(scrollToFirstValidationError, 0);
      setTimeout(scrollToFirstValidationError, 120);
      setTimeout(scrollToFirstValidationError, 280);
    });
    return result;
  };

  SimpleReactValidator.prototype.__scrollPatchApplied = true;
}

// LogRocket.init('rdqekt/petrometer');

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <>
    <Core />
    <SupabaseListener />
    <ConfigSyncListener />
  </>,
);
